import script from "./AccountTransferModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountTransferModal.vue?vue&type=script&setup=true&lang=js"

import "./AccountTransferModal.vue?vue&type=style&index=0&id=6c233df1&lang=scss"

const __exports__ = script;

export default __exports__